import { atom } from 'recoil';
export const lessonState = atom({
    key: 'lessonState',
    default: {
        isLoading: false,
        lesson: null,
        menuItems: [],
        isProgressSaved: false,
        reloadItems: false,
        firstLoad: false,
        progressLocalSaving: {},
        isProgressSaving: false,
        lessonCompleted: false,
        lessonStarted: false
    }
});
